"use client"

import { GoalsCenterContent } from "@/components/goals/goals-center-content"
import { GoalsRail } from "@/components/goals/goals-rail"
import { CenterColumn } from "@/components/layout/center-column"
import { useGoals } from "@/hooks/use-goals"
import Link from "next/link"

export default function GoalsPage() {
  const { activeGoal, isLoading } = useGoals()

  // Show "Planning Overview" when goal exists, "Goals" otherwise
  const pageTitle = activeGoal ? "Planning Overview" : "Goals"

  return (
    <div className="flex h-full flex-col lg:flex-row overflow-hidden relative">
      {/* Center column - exact same structure as Advisor/Memories */}
      <div className="flex-1 flex flex-col min-h-full" style={{ backgroundColor: "var(--surface)" }}>
        <div className="hidden lg:flex h-16 items-center justify-between px-6 md:px-10 lg:px-12 shrink-0 border-b border-white/5">
          <h1 className="min-w-0 truncate text-[30px] font-display font-normal text-foreground leading-[1.27]">
            {isLoading ? "Goals" : pageTitle}
          </h1>
          <Link
            href="/advisor?new=1&from=goals&scope=90_day_goal"
            className="shrink-0 text-sm font-sans font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Talk with Advisor →
          </Link>
        </div>

        {/* Content area - outer overflow hidden, inner scroll */}
        <div className="flex-1 overflow-hidden flex flex-col pb-3 relative">
          <div className="h-full overflow-y-auto pt-8">
            <CenterColumn>
              <GoalsCenterContent />
            </CenterColumn>
          </div>
        </div>
      </div>

      {/* Rail sibling - rendered at same hierarchy level as center column */}
      <GoalsRail />
    </div>
  )
}
